import { Box, Typography } from "@mui/material";
import CustomTooltip from "../../../../components/CustomTooltip";
import iconMapping from "../../../../icons/IconMapping";
import { ComplexEntityTypes } from "../../../../utils/constants";
import { getPrettyDate } from "../../../../utils/timestamp";
import { getEntityTypeDisplayName } from "../../../../utils/utils";

export const getAllEntitiesColumns = (colors, showLocalTime = true) => {
  return {
    entityType: {
      field: "entity_type",
      headerName: "Entity Type",
      minWidth: 130,
      sortable: true,
      resizable: true,
      disableReorder: true,
      renderCell: (params) => {
        const Icon = iconMapping[params.value] || iconMapping["Internet"];
        const entityTypeDisplayName = getEntityTypeDisplayName(params.value);
        return (
          <CustomTooltip title={entityTypeDisplayName}>
            <Box>
              <Icon
                style={{
                  color: colors.text_primary,
                  width: "20px",
                  height: "20px",
                }}
              />
            </Box>
          </CustomTooltip>
        );
      },
    },
    vulnerabilities: {
      field: "vulnerabilities",
      headerName: "Vulnerabilities",
      width: 150,
      minWidth: 150,
      align: "left",
      headerAlign: "left",
      disableReorder: true,
      valueGetter: (params) => {
        if (
          [
            ComplexEntityTypes.HOST,
            ComplexEntityTypes.SERVER,
            ComplexEntityTypes.DATA_STORE,
          ].includes(params.row.entity_type)
        )
          return params.row.vulnerability_count;
        return -1;
      },
      valueFormatter: (params) => (params.value >= 0 ? params.value : null),
      renderCell: (params) => (
        <Box display="flex" alignItems="center">
          <Typography variant="caption">
            {[
              ComplexEntityTypes.HOST,
              ComplexEntityTypes.SERVER,
              ComplexEntityTypes.DATA_STORE,
            ].includes(params.row.entity_type)
              ? params.value
              : "-"}
          </Typography>
        </Box>
      ),
    },
    last_seen: {
      field: "last_seen",
      headerName: "Last Seen",
      flex: 1,
      minWidth: 120,
      align: "left",
      headerAlign: "left",
      disableReorder: true,
      valueGetter: (params) =>
        params.row.last_collected_timestamp.timestamp_utc,
      valueFormatter: (params) =>
        params.value > 0 ? getPrettyDate(params.value, showLocalTime) : null,
      renderCell: (params) => (
        <Typography variant="caption" color={colors.grey_700}>
          {params.value > 0 ? getPrettyDate(params.value, showLocalTime) : "-"}
        </Typography>
      ),
    },
  };
};
